import React from 'react';
import { defaultCreateContactComponentState, ICreateContactComponentState } from './create-contact.state';
import { ICreateContactComponentProps } from './create-contact.props';
import { ReCaptchaComponent } from '../recaptcha/recaptcha.component';
import { validator, ValidationResult, validateObject, ITipoIdentificacion, ITipoPersona, DatePickerStrings, INivelEducativo, IProfesion, ITipoSolicitante, $_ } from '../../ioip/sdk/base';
import { PqrWebService } from '../../services/services';
import { ComboBox, TextField, PrimaryButton, IComboBoxOption, DefaultButton, DatePicker, DayOfWeek, Label, IChoiceGroupOption, ChoiceGroup } from "@fluentui/react";
import { NumberTextField } from '../../ioip/sdk/components';
import { TipoPersonaEnum } from './tipo-persona-enum';
import { TipoIdentificacionEnum } from './tipo-identificacion-enum';
import { onFormatDate } from '../../classes/shared/utilities';
import { AtencionPreferencialEnum } from '../../classes/shared/atencion-preferencias.enum';
import { Sede } from '../../classes/shared';
import PopupPanelComponent from '../popup/PopupPanel';
import { Column, Grid, Row, Subtitle } from '@ioip/core/lib';
import { DateTime } from 'ioip-base/lib/common';
import { ICountry } from '@ioip/archivox/lib';

export class CreateContactComponent extends React.Component<ICreateContactComponentProps, ICreateContactComponentState> {

  private _recaptcha: ReCaptchaComponent;
  private _pqrWebService: PqrWebService;
  private _validations: { [ key: string ]: any[] } = {
    IdTipoPersona: [ validator.invalid(0, 'Campo requerido') ],
    IdTipoIdentificacion: [ validator.invalid(0, 'Campo requerido') ],
    Identificacion: [ validator.required(true), validator.maxLength(128) ],
    Nombres: [ validator.required(true), validator.maxLength(128) ],
    Apellidos: [ validator.required(true), validator.maxLength(128) ],
    Direccion: [ validator.maxLength(128) ],
    Barrio: [ validator.maxLength(100) ],
    Telefono: [ validator.maxLength(20) ],
    Extension: [ validator.maxLength(15) ],
    Celular: [ validator.maxLength(20) ],

    NombresApoderado: [ validator.maxLength(128) ],
    ApellidosApoderado: [ validator.maxLength(128) ],
    IdentificacionApoderado: [ validator.maxLength(15) ],
    DireccionApoderado: [ validator.maxLength(128) ],
    TelefonoApoderado: [ validator.maxLength(64) ],
    EmailApoderado: [ validator.maxLength(128) ],

    Email: [
      validator.required(true),
      validator.maxLength(128),
      validator.email(),
      validator.custom(this._checkEmail.bind(this))
    ],
    Email2: [
      validator.required(true),
      validator.maxLength(128),
      validator.email(),
      validator.custom(this._checkEmail.bind(this))
    ],
    IdCiudad: [ validator.invalid(0, 'Campo requerido') ],
    IdDepartamento: [ validator.invalid(0, 'Campo requerido') ],
    IdPais: [ validator.invalid(0, 'Campo requerido') ],
    // IdPreguntaSecreta: [ validator.invalid(0, 'Campo requerido') ],
    // RespuestaSecreta: [ validator.required(true), validator.maxLength(128) ],
    Password: [
      validator.required(true),
      validator.maxLength(16),
      validator.custom(this._checkPassword.bind(this))
    ],
    Password2: [
      validator.required(true),
      validator.maxLength(16),
      validator.custom(this._checkPassword.bind(this))
    ]
  };

  private _validationJuridica: { [ key: string ]: any[] } = {
    NombreRepresentante: [ validator.required(true), validator.maxLength(128) ],
    EmailRepresentante: [
      validator.required(true),
      validator.maxLength(128),
      validator.email() ],
    CargoRepresentante: [ validator.required(true), validator.maxLength(128) ],
    Telefono: [ validator.required(true), validator.maxLength(20) ],
    TelefonoRepresentante: [ validator.required(true), validator.maxLength(20) ],
  };

  private _validationNatural: { [ key: string ]: any[] } = {
    PrimerNombre: [ validator.required(true), validator.maxLength(64), validator.onlyText() ],
    PrimerApellido: [ validator.required(true), validator.maxLength(64), validator.onlyText() ],
    SegundoNombre: [ validator.onlyText() ],
    SegundoApellido: [ validator.onlyText() ]
  };

  private async _onChangeOpcionActuaComoApoderado(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, option?: IChoiceGroupOption): Promise<void> {
    this.setState({
      model: {
        ...this.state.model,
        ActuaComoApoderado: option.key === '0' ? false : true,
        IdTipoIdentificacionApoderado: 0,
        IdentificacionApoderado: '',
        NombresApoderado: '',
        ApellidosApoderado: ''
      }
    });
  }

  private _onChangeOpcionAutorizaNotificacionEmail(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, option?: IChoiceGroupOption): void {
    this.setState({
      model: {
        ...this.state.model,
        AutorizaNotificacionEmail: option.key === '0' ? false : true
      }
    });
  }

  private _onChangeOpcionAutorizaLlamadaCelular(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, option?: IChoiceGroupOption): void {
    this.setState({
      model: {
        ...this.state.model,
        AutorizaLlamadaCelular: option.key === '0' ? false : true
      }
    });
  }

  private _onChangeOpcionAutorizaLlamadaFijo(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, option?: IChoiceGroupOption): void {
    this.setState({
      model: {
        ...this.state.model,
        AutorizaLlamadaFijo: option.key === '0' ? false : true
      }
    });
  }

  private _onChangeOpcionAutorizaNotificacionFisica(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, option?: IChoiceGroupOption): void {
    this.setState({
      model: {
        ...this.state.model,
        AutorizaNotificacionFisica: option.key === '0' ? false : true
      }
    });
  }

  constructor(props: any) {
    super(props);
    this.state = defaultCreateContactComponentState();
    this._pqrWebService = new PqrWebService();
    this._recaptcha = (null as any);
  }

  async componentDidMount(): Promise<void> {
    const result = await Promise.all([
      this._pqrWebService.getAllCountriesAsync(),
      this._pqrWebService.getAllDepartmentsAsync(),
      this._pqrWebService.getAllCitiesAsync(),
      this._pqrWebService.getAllIdentificationTypesAsync(),
      this._pqrWebService.getAllQuestionsAsync(),
      this._pqrWebService.getAllPreferentialCareTypesAsync(),
      this._pqrWebService.getAllDisabilitiesAsync(),
      this._pqrWebService.getAllGendersAsync(),
      this._pqrWebService.getAllEthnicGroupsAsync(),
      this._pqrWebService.getAllPersonTypesAsync()
    ]) as any;

    const [ educationLevels, professions, applicantTypes ] = await Promise.all([
      this._pqrWebService.getAllEducationLevelsAsync(),
      this._pqrWebService.getAllProfessionsAsync(),
      this._pqrWebService.getAllApplicantTypeAsync()
    ]) as any;

    this.setState({
      paises: result[ 0 ],
      paisesCO: result[ 0 ].map((o: ICountry) => ({ key: o.countryId, text: o.name })),
      departamentos: result[ 1 ],
      departamentosCO: [],
      ciudades: result[ 2 ],
      ciudadesCO: [],
      tiposIdentificacion: result[ 3 ],
      tiposIdentificacionCO: result[ 3 ].map((o: ITipoIdentificacion) => ({ key: o.IdTipoIdentificacion, text: o.Nombre })),
      tiposIdentificacionCOApoderado: result[ 3 ].filter(o => o.IdTipoIdentificacion !== TipoIdentificacionEnum.TarjetaIdentidad).map((o: ITipoIdentificacion) => ({ key: o.IdTipoIdentificacion, text: o.Nombre })),
      preguntas: result[ 4 ].filter(o => o.Activo).map(o => ({ key: o.IdPreguntaSecreta, text: o.Nombre })),
      atencionPreferencial: result[ 5 ].filter(o => o.Activo).map(o => ({ key: o.IdAntencionPreferencial, text: o.Nombre })),
      discapacidades: result[ 6 ].filter(o => o.Activo).map(o => ({ key: o.IdDiscapacidad, text: o.Nombre })),
      generos: result[ 7 ].filter(o => o.Activo).map(o => ({ key: o.IdGenero, text: o.Nombre })),
      gruposEtnicos: result[ 8 ].filter(o => o.Activo).map(o => ({ key: o.IdGrupoEtnico, text: o.Nombre })),
      tiposPersona: result[ 9 ],
      tiposPersonaCO: result[ 9 ].map((o: ITipoPersona) => ({ key: o.IdTipoPersona, text: o.Nombre })),
      nivelEducativo: educationLevels.filter(o => o.Activo).map((o: INivelEducativo) => ({ key: o.IdNivelEducativo, text: o.Nombre })),
      profesiones: professions.filter(o => o.Activo).map((o: IProfesion) => ({ key: o.IdProfesion, text: o.Nombre })),
      mostrarProfesion: Sede.Shared.Context.EnableContactProfession,
      mostrarTipoSolicitante: Sede.Shared.Context.EnableContactRequesterType,
      tiposSolicitante: applicantTypes.filter(o => o.Activo).map((o: ITipoSolicitante) => ({ key: o.IdTipoSolicitante, text: o.Nombre }))
    });
  }

  render(): JSX.Element {
    return <>
      <Grid>
        <Row>
          <Column size={12}>
            <h1 className="ms-font-xl ms-fontWeight-semibold">Registrar usuario</h1>
          </Column>
        </Row>
        <Row>
          <Column size={6}>
            <ComboBox
              label='Tipo de persona'
              selectedKey={this.state.model.IdTipoPersona}
              onChange={(_, value) => this._onChangeComboBox('IdTipoPersona', value)}
              options={this.state.tiposPersonaCO}
              useComboBoxAsMenuWidth={true}
              required={true}
              errorMessage={this.state.errors[ 'IdTipoPersona' ]}
            />
          </Column>
        </Row>
        {this.state.model.IdTipoPersona === TipoPersonaEnum.PersonaNatural && <>
          <Row>
            <Column size={6}>
              <ComboBox
                label='Atención preferencial o prioritaria'
                defaultSelectedKey='0'
                selectedKey={this.state.model.IdAntencionPreferencial}
                onChange={(_, value) => this._onChangeComboBox('IdAntencionPreferencial', value)}
                options={this.state.atencionPreferencial}
                useComboBoxAsMenuWidth={true}
                errorMessage={this.state.errors[ 'IdAntencionPreferencial' ]}
                required={this.state.model.IdTipoPersona === TipoPersonaEnum.PersonaNatural}
              />
            </Column>
            <Column size={6}>
              {this.state.model.IdAntencionPreferencial === AtencionPreferencialEnum.GrupoEtnico && <ComboBox
                label='Auto reconocimiento étnico-racial'
                selectedKey={this.state.model.IdGrupoEtnico}
                onChange={(_, value) => this._onChangeComboBox('IdGrupoEtnico', value)}
                options={this.state.gruposEtnicos}
                useComboBoxAsMenuWidth={true}
                required={this.state.model.IdAntencionPreferencial === AtencionPreferencialEnum.GrupoEtnico}
                errorMessage={this.state.errors[ 'IdGrupoEtnico' ]}
              />}
              {this.state.model.IdAntencionPreferencial === AtencionPreferencialEnum.Discapacidad && <ComboBox
                label='Discapacidad'
                selectedKey={this.state.model.IdDiscapacidad}
                onChange={(_, value) => this._onChangeComboBox('IdDiscapacidad', value)}
                options={this.state.discapacidades}
                useComboBoxAsMenuWidth={true}
                required={this.state.model.IdAntencionPreferencial === AtencionPreferencialEnum.Discapacidad}
                errorMessage={this.state.errors[ 'IdDiscapacidad' ]}
              />}
            </Column>
          </Row>
        </>}
        {this.state.mostrarTipoSolicitante && <Row>
          <Column size={6}>
            <ComboBox
              label='Usted se identifica como'
              selectedKey={this.state.model.IdTipoEntidad}
              onChange={(_, value) => this._onChangeComboBox('IdTipoEntidad', value)}
              options={this.state.tiposSolicitante}
              useComboBoxAsMenuWidth={true}
              errorMessage={this.state.errors[ 'IdTipoEntidad' ]}
              required={this.state.mostrarTipoSolicitante}
            />
          </Column>
        </Row>
        }
        {this.state.model.IdTipoPersona === TipoPersonaEnum.PersonaNatural && <Row>
          <Column size={12}>
            <ChoiceGroup
              defaultSelectedKey='0'
              selectedKey={this.state.model.ActuaComoApoderado === true ? '1' : '0'}
              options={this.state.opcionesSeleccionGrupo}
              onChange={this._onChangeOpcionActuaComoApoderado.bind(this)}
              label={'¿Actúa cómo apoderado?'}
            />
          </Column>
        </Row>}
        {this.state.model.ActuaComoApoderado && this.state.model.IdTipoPersona === TipoPersonaEnum.PersonaNatural && <>
          <div className='ms-Grid-row'>
            <div className='ms-Grid-col ms-u-sm12'>
              <Label>
                <span style={{ color: 'rgb(0, 120, 212)' }}>Datos del apoderado</span>
              </Label>
            </div>
          </div>
          <div className='ms-Grid-row'>
            <div className='ms-Grid-col ms-u-sm6'>
              <ComboBox
                autoComplete='on'
                errorMessage={this.state.errors[ 'IdTipoIdentificacionApoderado' ]}
                label='Tipo de identificación'
                onChange={(_, value) => this._onChangeComboBox('IdTipoIdentificacionApoderado', value)}
                options={this.state.tiposIdentificacionCOApoderado}
                required={this.state.model.ActuaComoApoderado}
                selectedKey={this.state.model.IdTipoIdentificacionApoderado}
                useComboBoxAsMenuWidth={true}
              />
            </div>
            <div className='ms-Grid-col ms-u-sm6'>
              <TextField
                errorMessage={this.state.errors[ 'IdentificacionApoderado' ]}
                label={'Número de identificación'}
                maxLength={15}
                onChange={(_, value) => this._onChangeTextField('IdentificacionApoderado', value)}
                placeholder={'Número de identificación del apoderado'}
                required={this.state.model.ActuaComoApoderado}
                value={this.state.model.IdentificacionApoderado}
              />
            </div>
          </div>
          <div className='ms-Grid-row'>
            <div className='ms-Grid-col ms-u-sm6'>
              <TextField
                placeholder={'Nombres'}
                label={'Nombres'}
                maxLength={128}
                required={this.state.model.ActuaComoApoderado}
                errorMessage={this.state.errors[ 'NombresApoderado' ]}
                onChange={(_, value) => this._onChangeTextField('NombresApoderado', value)}
                value={this.state.model.NombresApoderado}
              />
            </div>
            <div className='ms-Grid-col ms-u-sm6'>
              <TextField
                placeholder={'Apellidos'}
                label={'Apellidos'}
                maxLength={128}
                required={this.state.model.ActuaComoApoderado}
                errorMessage={this.state.errors[ 'ApellidosApoderado' ]}
                onChange={(_, value) => this._onChangeTextField('ApellidosApoderado', value)}
                value={this.state.model.ApellidosApoderado}
              />
            </div>
          </div>
          <div className='ms-Grid-row'>
            <div className='ms-Grid-col ms-u-sm6'>
              <TextField
                placeholder={'Email'}
                label={'Email'}
                maxLength={128}
                required={this.state.model.ActuaComoApoderado}
                errorMessage={this.state.errors[ 'EmailApoderado' ]}
                onChange={(_, value) => this._onChangeTextField('EmailApoderado', value)}
                value={this.state.model.EmailApoderado}
              />
            </div>
            <div className='ms-Grid-col ms-u-sm6'>
              <TextField
                placeholder={'Dirección'}
                label={'Dirección'}
                maxLength={128}
                required={false}
                errorMessage={this.state.errors[ 'DireccionApoderado' ]}
                onChange={(_, value) => this._onChangeTextField('DireccionApoderado', value)}
                value={this.state.model.DireccionApoderado}
              />
            </div>
          </div>
          <div className='ms-Grid-row'>
            <div className='ms-Grid-col ms-u-sm6'>
              <TextField
                placeholder={'Teléfono de contacto'}
                label={'Teléfono de contacto'}
                maxLength={64}
                errorMessage={this.state.errors[ 'TelefonoApoderado' ]}
                onChange={(_, value) => this._onChangeTextField('TelefonoApoderado', value)}
                value={this.state.model.TelefonoApoderado}
              />
            </div>
            <div className='ms-Grid-col ms-u-sm6'>
            </div>
          </div>
        </>}
        <Subtitle text='Información personal' />
        <Row>
          <Column size={6}>
            <ComboBox
              label='Tipo de identificación'
              selectedKey={this.state.model.IdTipoIdentificacion}
              onChange={(_, value) => this._onChangeComboBox('IdTipoIdentificacion', value)}
              options={this.state.tiposIdentificacionCO}
              useComboBoxAsMenuWidth={true}
              required={true}
              errorMessage={this.state.errors[ 'IdTipoIdentificacion' ]}
            />
          </Column>
          <Column size={6}>
            {(this.state.model.IdTipoIdentificacion) === TipoIdentificacionEnum.Nit && <TextField
              placeholder='NIT'
              label='NIT'
              maxLength={12}
              required={true}
              onChange={(_, value) => this._onChangeTextField('Identificacion', value)}
              errorMessage={this.state.errors[ 'Identificacion' ]}
              value={this.state.model.Identificacion}
            />}
            {this.state.model.IdTipoIdentificacion !== TipoIdentificacionEnum.Nit && <TextField
              placeholder='Identificación'
              label='Identificación'
              required={true}
              onChange={(_, value) => this._onChangeTextField('Identificacion', value)}
              errorMessage={this.state.errors[ 'Identificacion' ]}
              value={this.state.model.Identificacion}
            />}
          </Column>
        </Row>
        {((this.state.model.IdTipoPersona) === TipoPersonaEnum.PersonaNatural) && <>
          <Row>
            <Column size={6}>
              <TextField
                placeholder='Primer nombre'
                label='Primer nombre'
                maxLength={64}
                required={true}
                onChange={(_, value) => this._onChangeTextField('PrimerNombre', value)}
                errorMessage={this.state.errors[ 'PrimerNombre' ]}
                value={this.state.model.PrimerNombre}
              />
            </Column>
            <Column size={6}>
              <TextField
                placeholder='Segundo nombre'
                label='Segundo nombre'
                maxLength={64}
                onChange={(_, value) => this._onChangeTextField('SegundoNombre', value)}
                errorMessage={this.state.errors[ 'SegundoNombre' ]}
                value={this.state.model.SegundoNombre}
              />
            </Column>
          </Row>
          <Row>
            <Column size={6}>
              <TextField
                placeholder='Primer apellido'
                label='Primer apellido'
                maxLength={64}
                required={true}
                onChange={(_, value) => this._onChangeTextField('PrimerApellido', value)}
                errorMessage={this.state.errors[ 'PrimerApellido' ]}
                value={this.state.model.PrimerApellido}
              />
            </Column>
            <Column size={6}>
              <TextField
                placeholder='Segundo apellido'
                label='Segundo apellido'
                maxLength={64}
                onChange={(_, value) => this._onChangeTextField('SegundoApellido', value)}
                errorMessage={this.state.errors[ 'SegundoApellido' ]}
                value={this.state.model.SegundoApellido}
              />
            </Column>
          </Row>
        </>}
        {((this.state.model.IdTipoPersona) === TipoPersonaEnum.PersonaJuridica) && <>
          <Row>
            <Column size={6}>
              <TextField
                placeholder='Razon social'
                label='Razón social'
                maxLength={128}
                required={true}
                onChange={(_, value) => this._onChangeTextField('Nombres', value)}
                errorMessage={this.state.errors[ 'Nombres' ]}
                value={this.state.model.Nombres}
              />
            </Column>
            <Column size={6}>
              <TextField
                placeholder=''
                label='Nombre representante'
                maxLength={128}
                required={true}
                onChange={(_, value) => this._onChangeTextField('NombreRepresentante', value)}
                errorMessage={this.state.errors[ 'NombreRepresentante' ]}
                value={this.state.model.NombreRepresentante}
              />
            </Column>
          </Row>
          <Row>
            <Column size={6}>
              <TextField
                placeholder=''
                label='Correo electrónico representante'
                maxLength={128}
                required={true}
                onChange={(_, value) => this._onChangeTextField('EmailRepresentante', value)}
                errorMessage={this.state.errors[ 'EmailRepresentante' ]}
                value={this.state.model.EmailRepresentante}
              />
            </Column>
            <Column size={6}>
              <TextField
                placeholder=''
                label='Cargo representante'
                maxLength={128}
                required={true}
                onChange={(_, value) => this._onChangeTextField('CargoRepresentante', value)}
                errorMessage={this.state.errors[ 'CargoRepresentante' ]}
                value={this.state.model.CargoRepresentante}
              />
            </Column>
          </Row>
          <Row>
            <Column size={6}>
              <NumberTextField
                initialValue=''
                label='Teléfono representante'
                maxLength={10}
                required={true}
                onChanged={this._onChangeNumberTextField.bind(this, 'TelefonoRepresentante')}
                errorMessage={this.state.errors[ 'TelefonoRepresentante' ]}
                value={this.state.model.TelefonoRepresentante}
              />
            </Column>
          </Row>
        </>}
        <Row>
          <Column size={6}>
            <TextField
              placeholder={((this.state.model.IdTipoPersona) === TipoPersonaEnum.PersonaJuridica) ? 'Correo electrónico para notificaciones' : 'Correo electrónico'}
              label={((this.state.model.IdTipoPersona) === TipoPersonaEnum.PersonaJuridica) ? 'Correo electrónico para notificaciones' : 'Correo electrónico'}
              maxLength={128}
              required={true}
              onChange={(_, value) => this._onChangeTextField('Email', value)}
              errorMessage={this.state.errors[ 'Email' ]}
              value={this.state.model.Email}
            />
          </Column>
          <Column size={6}>
            <TextField
              placeholder={((this.state.model.IdTipoPersona) === TipoPersonaEnum.PersonaJuridica) ? 'Confirmar correo electrónico para notificaciones' : 'Confirmar correo electrónico'}
              label={((this.state.model.IdTipoPersona) === TipoPersonaEnum.PersonaJuridica) ? 'Confirmar correo electrónico para notificaciones' : 'Confirmar correo electrónico'}
              maxLength={128}
              required={true}
              onChange={(_, value) => this._onChangeTextField('Email2', value)}
              errorMessage={this.state.errors[ 'Email2' ]}
              value={this.state.model.Email2}
            />
          </Column>
        </Row>
        <Row>
          <Column size={6}>
            <ComboBox
              label='País de notificación'
              selectedKey={this.state.model.IdPais}
              onChange={(_, value) => this._onChangeComboBox('IdPais', value)}
              options={this.state.paisesCO}
              required={true}
              useComboBoxAsMenuWidth={true}
              errorMessage={this.state.errors[ 'IdPais' ]}
            />
          </Column>
          <Column size={6}>
            <ComboBox
              label='Departamento de notificación'
              selectedKey={this.state.model.IdDepartamento}
              onChange={(_, value) => this._onChangeComboBox('IdDepartamento', value)}
              options={this.state.departamentosCO}
              useComboBoxAsMenuWidth={true}
              required={true}
              errorMessage={this.state.errors[ 'IdDepartamento' ]}
            />
          </Column>
        </Row>
        <Row>
          <Column size={6}>
            <ComboBox
              label='Ciudad de notificación'
              selectedKey={this.state.model.IdCiudad}
              onChange={(_, value) => this._onChangeComboBox('IdCiudad', value)}
              options={this.state.ciudadesCO}
              useComboBoxAsMenuWidth={true}
              required={true}
              errorMessage={this.state.errors[ 'IdCiudad' ]}
            />
          </Column>
          <Column size={6}>

          </Column>
        </Row>
        {this.state.model.IdTipoPersona === TipoPersonaEnum.PersonaNatural && <>
          <Row>
            <Column size={6}>
              <DatePicker
                firstDayOfWeek={DayOfWeek.Sunday}
                strings={DatePickerStrings}
                label='Fecha de nacimiento'
                formatDate={onFormatDate}
                onSelectDate={this._OnChangeModelDate.bind(this, 'FechaNacimiento')}
                value={this.state.model.FechaNacimiento}
                disableAutoFocus={true}
              />
            </Column>
            <Column size={6}>
              <ComboBox
                label='Género'
                selectedKey={this.state.model.IdGenero}
                onChange={(_, value) => this._onChangeComboBox('IdGenero', value)}
                options={this.state.generos}
                useComboBoxAsMenuWidth={true}
              />
            </Column>
          </Row>
          <Row>
            <Column size={6}>
              <ComboBox
                label='Nivel de escolaridad'
                selectedKey={this.state.model.IdNivelEducativo}
                onChange={(_, value) => this._onChangeComboBox('IdNivelEducativo', value)}
                options={this.state.nivelEducativo}
                useComboBoxAsMenuWidth={true}
              />
            </Column>

            {this.state.mostrarProfesion && <Column size={6}>
              <ComboBox
                label='Profesión u oficio'
                selectedKey={this.state.model.IdProfesion}
                onChange={(_, value) => this._onChangeComboBox('IdProfesion', value)}
                options={this.state.profesiones}
                useComboBoxAsMenuWidth={true}
              />
            </Column>}
          </Row>
        </>}
        <Row>
          <Column size={6}>
            <TextField
              placeholder='Dirección física'
              label='Dirección física'
              maxLength={128}
              required={this.state.model.AutorizaNotificacionFisica}
              onChange={(_, value) => this._onChangeTextField('Direccion', value)}
              errorMessage={this.state.errors[ 'Direccion' ]}
              value={this.state.model.Direccion}
            />
          </Column>
          <Column size={6}>
            <TextField
              placeholder='Barrio'
              label='Barrio'
              maxLength={100}
              onChange={(_, value) => this._onChangeTextField('Barrio', value)}
              errorMessage={this.state.errors[ 'Barrio' ]}
              value={this.state.model.Barrio}
            />
          </Column>
        </Row>
        <Row>
          <Column size={6}>
            <NumberTextField
              initialValue=''
              label='Celular'
              maxLength={10}
              onChanged={this._onChangeNumberTextField.bind(this, 'Celular')}
              errorMessage={this.state.errors[ 'Celular' ]}
              value={this.state.model.Celular}
              required={this.state.model.AutorizaLlamadaCelular}
            />
          </Column>
          <Column size={4}>
            <NumberTextField
              initialValue=''
              label='Teléfono'
              maxLength={10}
              required={(this.state.model.IdTipoPersona === TipoPersonaEnum.PersonaJuridica) || (this.state.model.IdTipoPersona === TipoPersonaEnum.PersonaNatural && this.state.model.AutorizaLlamadaFijo)}
              onChanged={this._onChangeNumberTextField.bind(this, 'Telefono')}
              errorMessage={this.state.errors[ 'Telefono' ]}
              value={this.state.model.Telefono}
            />
          </Column>
          <Column size={2}>
            <NumberTextField
              initialValue=''
              label='Extensión'
              maxLength={8}
              onChanged={this._onChangeNumberTextField.bind(this, 'Extension')}
              errorMessage={this.state.errors[ 'Extension' ]}
              value={this.state.model.Extension}
            />
          </Column>
        </Row>
        <Row>
          <Column size={6}>
            <TextField
              placeholder='Contraseña'
              label='Contraseña'
              maxLength={16}
              required={true}
              type='password'
              onChange={(_, value) => this._onChangeTextField('Password', value)}
              errorMessage={this.state.errors[ 'Password' ]}
              value={this.state.model.Password}
            />
          </Column>
          <Column size={6}>
            <TextField
              placeholder='Confirmar contraseña'
              label='Confirmar contraseña'
              maxLength={16}
              required={true}
              type='password'
              onChange={(_, value) => this._onChangeTextField('Password2', value)}
              errorMessage={this.state.errors[ 'Password2' ]}
              value={this.state.model.Password2}
            />
          </Column>
        </Row>
        {this.state.model.IdTipoPersona === TipoPersonaEnum.PersonaNatural && <>
          <Row>
            <Column size={6}>
              <ChoiceGroup
                defaultSelectedKey='0'
                selectedKey={this.state.model.AutorizaNotificacionFisica === true ? '1' : '0'}
                options={this.state.opcionesSeleccionGrupo}
                onChange={this._onChangeOpcionAutorizaNotificacionFisica.bind(this)}
                label={'¿Autoriza recibir notificación en la dirección registrada?'}
              />
            </Column>
            <Column size={6}>
              <ChoiceGroup
                defaultSelectedKey='0'
                selectedKey={this.state.model.AutorizaLlamadaCelular === true ? '1' : '0'}
                options={this.state.opcionesSeleccionGrupo}
                onChange={this._onChangeOpcionAutorizaLlamadaCelular.bind(this)}
                label={'¿Autoriza notificación o recibir llamadas por teléfono Celular?'}
              />
            </Column>
          </Row>
          <Row>
            <Column size={6}>
              <ChoiceGroup
                defaultSelectedKey='0'
                selectedKey={this.state.model.AutorizaLlamadaFijo === true ? '1' : '0'}
                options={this.state.opcionesSeleccionGrupo}
                onChange={this._onChangeOpcionAutorizaLlamadaFijo.bind(this)}
                label={'¿Autoriza recibir llamadas a su teléfono fijo?'}
                className="defaultChoiceGroup"
              />
            </Column>
            <Column size={6}>
              <ChoiceGroup
                defaultSelectedKey='0'
                selectedKey={this.state.model.AutorizaNotificacionEmail === true ? '1' : '0'}
                options={this.state.opcionesSeleccionGrupo}
                onChange={this._onChangeOpcionAutorizaNotificacionEmail.bind(this)}
                label={'¿Autoriza notificación por correo electrónico?'}
              />
            </Column>
          </Row>
        </>}
        <br />
        <Row style={{ paddingTop: '8px' }}>
          <Column size={12}>
            <ReCaptchaComponent
              onInitialize={component => {
                this._recaptcha = component;
                setTimeout(this._recaptcha.initialize, 2000);
              }}
            />
            <small style={{ color: 'red' }}> {this.state.errors[ 'recaptcha' ]}</small>
          </Column>
        </Row>
        <Row>
          <Column size={12} style={{ marginTop: '15px', textAlign: 'right' }}>
            <PrimaryButton
              text='Registrarme'
              onClick={this._saveAsync.bind(this)}
            />
            <span>&nbsp;&nbsp;</span>
            <DefaultButton
              text='Volver a inicio'
              href='#/home'
            />
          </Column>
        </Row>
      </Grid>
      <PopupPanelComponent
        onAccept={() => {
          this.setState({
            model: {
              ...(this.state.model as any),
              AutorizaTratamientoDatos: true
            },
            mostrarPanelPoliticaDatos: false
          })
        }}
        onCancel={() => {
          this.setState({
            model: {
              ...(this.state.model as any),
              AutorizaTratamientoDatos: false
            },
            mostrarPanelPoliticaDatos: false
          })
        }}
        text={Sede.Shared.Context.PoliticaTratamientoDatosPersonales}
        title=''
        show={this.state.mostrarPanelPoliticaDatos}
        closeButtonText= 'Rechazar'
      />
    </>
  }

  protected _onChangeModel(model: any): void { }

  protected _OnChangeModelDate(property: string, date: Date | null | undefined): void {
    this.setState({
      model: {
        ...(this.state.model as any),
        [ property ]: date
      }
    });
    this._onChangeModel({
      ...(this.state.model as any),
      [ property ]: date
    });
  };

  protected _changeModelCheckBox(property: string, ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean): void {
    this.setState({
      model: {
        ...(this.state.model as any),
        [ property ]: checked
      }
    });
  }

  private _updateErrors(errors: { [ key: string ]: string }): void {
    this.setState({ errors });
  }

  private async _saveAsync(): Promise<void> {
    if (this.state.model.IdTipoPersona === TipoPersonaEnum.PersonaNatural) {
      this.state.model.Nombres = this.state.model.PrimerNombre + ' ' + this.state.model.SegundoNombre;
      this.state.model.Apellidos = this.state.model.PrimerApellido + ' ' + this.state.model.SegundoApellido;
    }
    else {
      this.state.model.Apellidos = this.state.model.NombreRepresentante;
    }
    let validations: { [ key: string ]: any[] };
    let _validationTipoEntidad: { [ key: string ]: any[] } = {};

    if (this.state.mostrarTipoSolicitante) {
      _validationTipoEntidad = {
        IdTipoEntidad: [ validator.invalid(0, 'Campo requerido') ]
      }
    }

    if (this.state.model.IdTipoPersona === TipoPersonaEnum.PersonaNatural) {
      let _validationAtencionPreferencial: { [ key: string ]: any[] } = {};
      let _validationIdentity: { [ key: string ]: any[] } = {};
      let _validationApoderado: { [ key: string ]: any[] } = {};
      let _validationNotificacionFisica: { [ key: string ]: any[] } = {};
      let _validationLlamadasFijo: { [ key: string ]: any[] } = {};
      let _validationLlamadasCelular: { [ key: string ]: any[] } = {};

      _validationAtencionPreferencial = {
        IdAntencionPreferencial: [ validator.invalid(0, 'Campo requerido') ]
      };

      if (this.state.model.IdTipoIdentificacion === TipoIdentificacionEnum.CedulaCiudadania) {
        _validationIdentity = {
          Identificacion: [ validator.required(true), validator.identity(), validator.maxLength(20) ]
        };
      }

      if (this.state.model.IdAntencionPreferencial === AtencionPreferencialEnum.Discapacidad) {
        _validationAtencionPreferencial = {
          IdDiscapacidad: [ validator.invalid(0, 'Campo requerido') ]
        };
      }
      else if (this.state.model.IdAntencionPreferencial === AtencionPreferencialEnum.GrupoEtnico) {
        _validationAtencionPreferencial = {
          IdGrupoEtnico: [ validator.invalid(0, 'Campo requerido') ]
        };
      }

      if (this.state.model.ActuaComoApoderado) {
        _validationApoderado = {
          IdentificacionApoderado: [ validator.required(true), validator.identity() ],
          IdTipoIdentificacionApoderado: [ validator.invalid(0, 'Campo requerido') ],
          NombresApoderado: [ validator.required(true) ],
          ApellidosApoderado: [ validator.required(true) ],
          EmailApoderado: [ validator.required(true) ]
        };
      }

      if (this.state.model.AutorizaLlamadaCelular) {
        _validationLlamadasCelular = {
          Celular: [ validator.required(true) ]
        };
      }

      if (this.state.model.AutorizaLlamadaFijo) {
        _validationLlamadasFijo = {
          Telefono: [ validator.required(true) ]
        };
      }

      if (this.state.model.AutorizaNotificacionFisica) {
        _validationNotificacionFisica = {
          Direccion: [ validator.required(true) ]
        };
      }

      validations = { ...this._validations, ...this._validationNatural, ..._validationAtencionPreferencial, ..._validationIdentity, ..._validationApoderado, ..._validationNotificacionFisica, ..._validationLlamadasCelular, ..._validationLlamadasFijo, ..._validationTipoEntidad }
    }
    else {
      validations = { ...this._validations, ...this._validationJuridica, ..._validationTipoEntidad }
    }

    if (validateObject(this.state.model, validations, this._updateErrors.bind(this))) {
      try {
        const model = this.state.model;
        model.Cargo = void 0;
        model.Ciudad = void 0;
        model.Departamento = void 0;
        model.Pais = void 0;
        model.TipoContacto = void 0;
        model.TipoIdentificacion = void 0;

        if (this.state.model.IdTipoPersona === TipoPersonaEnum.PersonaNatural && !$_.isNull(this.state.model.FechaNacimiento)) {
          const dtNow = DateTime.Now.TruncateDate();
          const dtValue = new DateTime(this.state.model.FechaNacimiento).TruncateDate();
          const dtOneMonthAgo = new Date(dtNow.getFullYear(), dtNow.getMonth() - 1, dtNow.getDate());

          // Comparar la fecha ingresada con la fecha un mes atrás
          if (dtValue > dtOneMonthAgo) {
            alert('Debe seleccionar una fecha válida de nacimiento');
            return;
          }
        }

        const resultCaptcha = this._recaptcha.isValid();
        if (resultCaptcha.isCaptchaValid === false) {
          alert('Debe completar la validación de seguridad');
          return;
        }

        if (!model.AutorizaNotificacionEmail && !model.AutorizaNotificacionFisica) {
          alert('Debe seleccionar algún tipo de notificación, ya sea por correo electrónico o en la dirección registrada')
          return;
        }

        this.setState({ isSaving: true });
        await this._pqrWebService.createContactAsync(model, resultCaptcha.recaptchaToken);
        this.setState({ isSaving: false });
        alert(`Se ha enviado a su dirección de correo registrado un enlace, por favor ingresar para activar la cuenta`);
        window.location.href = '#/home';
      } catch (ex) {
        alert('Ya existe un contacto con la misma identificación, para obtener la contraseña ingrese a la opción Olvidé mi contraseña');
      }
    }
  }

  private _checkPassword(): ValidationResult {
    const result: ValidationResult = new ValidationResult();
    if (this.state.model.Password !== this.state.model.Password2) {
      result.hasError = true;
      result.errorMessage = 'Las constraseñas establecidas no coinciden';
    }
    return result;
  }

  private _checkEmail(): ValidationResult {
    const result: ValidationResult = new ValidationResult();
    if (this.state.model.Email.toLowerCase() !== this.state.model.Email2.toLowerCase()) {
      result.hasError = true;
      result.errorMessage = 'Las direcciones de correo electrónico no coinciden';
    }
    return result;
  }

  private async _onChangeComboBox(property: string, option?: IComboBoxOption, index?: number, value?: string, submitPendingValueEvent?: any): Promise<void> {
    const state = {
      ...this.state,
      model: {
        ...this.state.model,
        [ property ]: Number(option.key)
      }
    };

    if (property === 'IdTipoPersona') {
      let result = await this._pqrWebService.getIdentificationTypesByIdPersonaAsync(Number(option.key));
      state.tiposIdentificacionCO = result.map((o: ITipoIdentificacion) => ({ key: o.IdTipoIdentificacion, text: o.Nombre }));
      state.tiposIdentificacionCOApoderado = result.filter(o => o.IdTipoIdentificacion !== TipoIdentificacionEnum.TarjetaIdentidad).map((o: ITipoIdentificacion) => ({ key: o.IdTipoIdentificacion, text: o.Nombre }));

      if (state.mostrarTipoSolicitante === true) {
        let resultTiposSolicitante = await this._pqrWebService.getAllApplicantTypeAsync();
        state.tiposSolicitante = resultTiposSolicitante.filter(o => o.Activo && o.IdTipoPersona === Number(option.key)).map((o: ITipoSolicitante) => ({ key: o.IdTipoSolicitante, text: o.Nombre }))
      }
    }

    if (property === 'IdTipoIdentificacion') {
      if (Number(option.key) === TipoIdentificacionEnum.TarjetaIdentidad) {
        let result = await this._pqrWebService.getChildGendersAsync();
        state.generos = result.filter(o => o.Activo).map(o => ({ key: o.IdGenero, text: o.Nombre }));
      }
      else {
        let result = await this._pqrWebService.getAllGendersAsync();
        state.generos = result.filter(o => o.Activo).map(o => ({ key: o.IdGenero, text: o.Nombre }));
      }
    }

    if (property === 'IdPais') {
      state.departamentosCO = state.departamentos.filter(o => o.countryId === Number(option.key)).map(o => ({ key: o.departmentId, text: o.name }));
      state.ciudadesCO = [];
    }

    if (property === 'IdDepartamento') {
      state.ciudadesCO = state.ciudades.filter(o => o.departmentId === Number(option.key)).map(o => ({ key: o.cityId, text: o.name }));
    }

    this.setState(state);

  }

  private _onChangeTextField(property: string, value: string): void {
    const state = {
      model: {
        ...this.state.model,
        [ property ]: value
      }
    };
    this.setState(state);
  }

  private _onChangeNumberTextField(property: string, value: number): void {
    const state = {
      model: {
        ...this.state.model,
        [ property ]: value.toString()
      }
    };
    this.setState(state);
  }

}